module.exports = __webpack_public_path__ + "static/fonts/iconfont.a0216f6c.woff2";